import { render, staticRenderFns } from "./MppUserGrowth.vue?vue&type=template&id=66f43926&scoped=true"
import script from "./MppUserGrowth.vue?vue&type=script&lang=js"
export * from "./MppUserGrowth.vue?vue&type=script&lang=js"
import style0 from "./MppUserGrowth.vue?vue&type=style&index=0&id=66f43926&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f43926",
  null
  
)

export default component.exports